import React, { Children, isValidElement, ReactElement } from 'react';
import { ContentComponentProps } from '../../../utils/pageBuilder/types';

interface ImageElementProps {
  src?: string;
  alt?: string;
  title?: string;
  loading?: 'lazy';
  className?: string;
  ['data-element']?: string;
}

export function PageBuilderImage({
  children,
  contentType,
  'data-pb-style': styleId
}: ContentComponentProps) {
  const childrenList = Children.toArray(children);

  const findByElement = (dataElement: string) =>
    childrenList.find(
      (child): child is ReactElement<ImageElementProps> =>
        isValidElement<ImageElementProps>(child) &&
        child.props['data-element'] === dataElement
    );

  const mobileImage = findByElement('mobile_image');
  const desktopImage = findByElement('desktop_image');

  if (!mobileImage || !mobileImage.props.src) {
    return null;
  }

  return (
    <picture
      className={contentType}
      data-pb-style={styleId as string | undefined}
    >
      {desktopImage?.props.src && (
        <source media="(min-width: 1200px)" srcSet={desktopImage.props.src} />
      )}
      <img
        src={mobileImage.props.src}
        alt={mobileImage.props.alt}
        title={mobileImage.props.title}
        loading={mobileImage.props.loading}
        className={mobileImage.props.className}
      />
    </picture>
  );
}
